export const CRITICAL_ALERTS_URL = '/v2/flashalerts';
export const ADMIN_URL = '/admin/v2';
